import { getBrowserLang } from '@jsverse/transloco';

export type Currency = 'eur' | 'usd' | 'gbp';
export const Currency = {
  EUR: 'eur' as Currency,
  USD: 'usd' as Currency,
  GBP: 'gbp' as Currency,
};

export const format = (priceInCent: string | number | undefined, currency: Currency | undefined) => {
  let priceNumber = Number(priceInCent);
  if (isNaN(priceNumber)) {
    console.warn(`[CurrencyFormatter] Invalid price given:  ${priceInCent}.`);
    priceNumber = 0;
  } else {
    priceNumber = priceNumber / 100;
  }

  const locale = getBrowserLang();

  const currencySymbol = currency?.toLocaleUpperCase() || '';
  if (!Object.keys(Currency).includes(currencySymbol)) {
    const defaultCurrency = 'EUR';
    console.warn(`[CurrencyFormatter] Currency ${currencySymbol} is not supported. Defaulting to ${defaultCurrency}.`);
    return new Intl.NumberFormat(locale, { style: 'currency', currency: defaultCurrency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
      priceNumber,
    );
  }

  return new Intl.NumberFormat(locale, { style: 'currency', currency: currencySymbol, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
    priceNumber,
  );
};
